module.exports = __webpack_public_path__ + "static/tiktok-b8f43535a3676d7cea37a36ceed7b5d6.png";